/**
 * 문자열 / 문자열배열 / undefined 를 trim된 비어있지 않은 문자열 배열로 정규화한다.
 * "a,b,c" 처럼 콤마로 구분된 값이나, ["a,b", "c"] 처럼 배열 안에 콤마가 섞인 값도 모두 분리한다.
 */
export function toStringArray(value: unknown): string[] | undefined {
    if (value == null || value === "") return undefined;
    const raw = Array.isArray(value) ? value : [value];
    const cleaned = raw
        .flatMap((v) => String(v).split(","))
        .map((v) => v.trim())
        .filter(Boolean);
    return cleaned.length > 0 ? cleaned : undefined;
}
